/**
 * This function splits the TALKS roomname into channelId and webcastId.
 * @param {string} roomname The roomname split by a hyphen.
 * @returns An object with channelId and webcastId
 */

export interface Split {
  channelId: number
  webcastId: number
}

export default function (roomname: string): Split | null {

  const parsedRoomname: number[] = roomname
    .split('-')
    .map(id => parseInt(id))
    .filter(id => !isNaN(id))

  if (parsedRoomname.length !== 2) return null

  const [ channelId, webcastId ] = parsedRoomname

  return { channelId, webcastId }

}
